module.exports = __webpack_public_path__ + "img/rule deal player.6050a170.png";